export default __webpack_public_path__ + "static/media/icon_star_3.b6652697.svg";